import Vue from 'vue';

export const bus = new Vue({});

Vue.prototype.$bus = bus;
declare module 'vue/types/vue' {
  interface Vue {
    $bus: Vue;
  }
}
